<template>
  <div class="user-info"
       :class="{ 'user-info_is-master': isMaster }">
    <i v-if="user.hasChildren"
       :class=" `mdi ${icon}`"
       @click="toogleNode"></i>

    <p class="name-text"
       @click="toogleNode">{{user.name}}</p>
  </div>
</template>

<script>
import Vue from "vue";
import EventBus from "@packages/event-bus";

export default {
  props: {
    user: {
      type: Object,
    },
  },

  created() {
    EventBus.$on("OPEN_NODE", this.openNodeHandler);
  },

  beforeDestroy() {
    EventBus.$off("OPEN_NODE", this.openNodeHandler);
  },

  components: {},

  watch: {},

  data() {
    return {
      isOpen: false,
    };
  },

  mixins: [],

  computed: {
    icon() {
      return this.isOpen ? "mdi-chevron-down" : "mdi-chevron-right";
    },
    isMaster() {
      return this.user.id === this.user.masterId;
    },
  },

  methods: {
    openNodeHandler({ id }) {
      if (this.user.id === id) {
        this.user.hasChildren = true;
        this.openNode();
      }
    },
    async toogleNode() {
      if (!this.isOpen) {
        await this.openNode();
      } else {
        Vue.set(this.user, "children", []);
        this.isOpen = false;
      }
    },
    async openNode() {
      try {
        const children = await this.$api.userLogin.open({
          id: this.user.id,
        });

        Vue.set(
          this.user,
          "children",
          children.map((child) => {
            return {
              ...child,
              permissions: JSON.parse(child.permissions),
              children: child.children || [],
            };
          })
        );

        this.isOpen = true;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.user-info {
  display: flex;
  height: 55px;
  align-items: center;
  border-bottom: 1px solid #c8c8c8;
  width: 100%;
  padding-left: 5px;

  i {
    cursor: pointer;
    padding-right: 5px;
  }

  .name-text {
    margin: 0;
    cursor: pointer;
    user-select: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.user-info_is-master {
    color: $primary;
  }
}
</style>
